<template>
    <div class="avatar" :style="{ height: size + 'px' }">
        <span v-if="genius" :style="{ color: 'white',  outline: `${this.badgeSize.outline}px solid rgba(255,255,255,0.5)`, background: '#f0b100', position: 'absolute', top: `-${this.badgeSize.corner}px`, left: `-${this.badgeSize.corner}px`, borderRadius: '50%', padding: 0, height: `${this.badgeSize.width}px`, width: `${this.badgeSize.width}px`, zIndex: 2 }">
            <span class="material-icons" :style="{ fontSize: `${this.badgeSize.font}px`, position: 'absolute', top: `${this.badgeSize.star}px`, left: `${this.badgeSize.star}px` }">star</span>
        </span>
        <span class="avatar-inner" ref="avatar" :title="labelPrefix + displayAltText"  :style="'width: ' + size + 'px; height: ' + size + 'px; ' + (round ? 'border-radius: 50%;' : '')">
            <vue-avatar :custom-style="{backgroundSize: 'cover', backgroundPosition: 'center'}" :src="displayUrl" :rounded="round" v-if="displayAltText" :username="displayAltText" :size="size" :background-color="backgroundColour" :color="colour"></vue-avatar>
            <span v-if="editable" class="avatar-edit">
                <span>Change</span>
            </span>
        </span>
        <ui-popover v-if="editable" ref="avatarOptions" :trigger="$refs.avatar">
            <ui-menu :options="changeAvatarOptions" @select="handleChangeAvatarClick"></ui-menu>
        </ui-popover>
        <ui-tooltip
            v-if="showLabel"
            :trigger="$refs.avatar"
        >{{ tooltipText ? tooltipText : labelPrefix + displayAltText }}</ui-tooltip>
    </div>
</template>

<style lang="scss">
    .avatar-edit { display: none; }
    .avatar { display: inline-block; vertical-align: middle; position: relative; }
    .avatar-inner {
        display: inline-block; overflow: hidden; position: relative;
    }
    .avatar-inner:hover {
        .avatar-edit {
            display:block;
            background: rgba(0,0,0,.4);
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            cursor: pointer;

            & > span {
                display: block;
                position: relative;
                top: 50%;
                left: 52%;
                text-transform: uppercase;
                font-size: .8rem;
                font-weight: bold;
                transform: translate(-50%, -50%);
                color: #fff;
            }
        }
    }
</style>

<script>
    import VueAvatar from 'vue-avatar'

    const changeAvatarOptions = [
        {
            'label': 'Upload a new picture',
            'id': 'upload'
        }, {
            'label': 'Set a background colour',
            'id': 'pick_colour'
        }, {
            'label': 'Reset',
            'id': 'reset'
        }
    ]

    export default {
        components: { VueAvatar },
        props: {
            editable: {
                type: Boolean,
                default: false,
            },
            url: {
                type: String,
            },
            altText: {
                type: String,
            },
            tooltipText: {
                type: String
            },
            user: { },
            contact: { },
            showLabel: {
                type: Boolean,
                default: true,
            },
            labelPrefix: {
                type: String,
                default: ''
            },
            size: {
                type: Number,
                default: 32
            },
            round: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                changeAvatarOptions
            }
        },
        methods: {
            handleChangeAvatarClick(e) {
                if (e.id === 'upload') {
                    this.$emit('upload')
                } else if (e.id === 'reset') {
                    if (this.user && this.user.avatar_url) {
                        this.$emit('remove-avatar')
                    }
                    if (this.user && this.user.avatar_colour) {
                        this.$emit('reset-colour')
                    }
                } else if (e.id === 'pick_colour') {
                    this.$emit('pick-colour')
                }

                this.$refs.avatarOptions.close();
            }
        },
        computed: {
            badgeSize() {
                return {
                    width: this.size / 2.5,
                    corner: this.size / 9,
                    font: this.size / 2.9166666667,
                    outline: this.size / 17.5,
                    star: this.size / 32
                }
            },
            colour() {
                 if (this.contact) {
                    return '#fff'
                 }

                 if (this.backgroundColour) {
                    const hex = this.backgroundColour.replace('#', '');
                    const r = parseInt(hex.substring(0, 2), 16);
                    const g = parseInt(hex.substring(2, 4), 16);
                    const b = parseInt(hex.substring(4, 6), 16);
                    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

                    return brightness > 128 ? '#333' : '#fff';
                 }
            },
            backgroundColour() {
                if (this.contact) {
                    return '#ccc'
                }
                
                if (this.user) {
                    return this.user.avatar_colour;
                }
            },
            displayUrl() {
                if (this.url) {
                    return this.url;
                }

                if (this.user) {
                    return this.user.avatar_url;
                }
            },
            displayAltText() {
                if (this.altText) {
                    return this.altText;
                }

                if (this.user) {
                    return this.user.name;
                }

                if (this.contact) {
                    return this.contact.primary_display_as
                }
            },
            genius() {
                if (this.user) {
                    return this.user.is_genius;
                }

                return false;
            },
        }
    }
</script>